import { io, type Socket } from "socket.io-client";

import { env } from "@/configs/env";

/**
 * Socket hodisalari — backend `realtime.events.ts` ning ko'zgusi.
 *
 * Panel foydalanuvchi hodisalarini TINGLAMAYDI (`notification`,
 * `chat:message`): moderator o'z shaxsiy takliflarini panelda emas,
 * saytda ko'radi. Bu yerda faqat navbat haqidagi hodisa bor.
 */
export const RealtimeEvent = {
  /** Navbatga yangi ish tushdi: ariza, shikoyat, so'rov yoki to'lov. */
  AdminNotification: "admin:notification",
  /** Server tokenni qabul qilmadi — qayta kirish kerak. */
  Unauthorized: "unauthorized",
} as const;

/** Backend `admin-notification-types.ts` bilan bir xil ro'yxat. */
export type AdminNotificationType =
  "host_application_submitted" | "report_submitted" | "withdrawal_created" | "payment_succeeded";

export interface AdminNotificationPayload {
  entityId?: string;
  userId?: string;
  userName?: string;
  coffees?: number;
  amountUzs?: number;
  reportReason?: string;
}

export interface AdminNotification {
  id: string;
  type: AdminNotificationType;
  payload: AdminNotificationPayload;
  createdAt: string;
}

/**
 * Socket manzili API manzilidan olinadi.
 *
 * Alohida env o'zgaruvchisi qo'shilmadi: socket API bilan bir xil
 * serverda turadi, va ikkita manzilni alohida sozlash — ularning
 * bir-biridan ajralib ketishining eng oson yo'li (web'dagi bilan bir
 * xil qaror).
 */
const socketOrigin = (): string => new URL(env.VITE_API_BASE_URL).origin;

let socket: Socket | null = null;

/**
 * Yagona ulanish.
 *
 * Bitta socket butun panel uchun: har bir komponent o'zi ulansa,
 * bitta moderator o'nlab ulanish ochardi va har bir hodisa o'nta
 * nusxada kelardi.
 *
 * Autentifikatsiya cookie orqali — `withCredentials`. Token JS ga
 * ko'rinmaydi (`httpOnly`), ya'ni uni qo'lda uzatib ham bo'lmaydi.
 * Xonalar esa qo'l berish paytida serverning o'zi tomonidan
 * tanlanadi: klient "meni shu ruxsat xonasiga qo'sh" deb ayta
 * olmaydi.
 */
export function getSocket(): Socket {
  socket ??= io(socketOrigin(), {
    path: "/ws",
    withCredentials: true,
    // Avval polling, keyin websocket: proksi websocket'ni bloklasa
    // ham ulanish ishlaydi, shunchaki sekinroq.
    transports: ["polling", "websocket"],
    autoConnect: false,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10_000,
  });

  return socket;
}

/** Chiqishda: ulanishni uzadi va keyingi kirish uchun tozalaydi. */
export function closeSocket(): void {
  socket?.disconnect();
  socket = null;
}
